import { render, staticRenderFns } from "./CreateDocumentHeroBox.vue?vue&type=template&id=64be1df9&scoped=true&"
import script from "./CreateDocumentHeroBox.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentHeroBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be1df9",
  null
  
)

export default component.exports